import { Injectable } from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {first, take} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {CommissionAnnex} from "../interface/commission-annex";
import {Submissions} from "../interface/submissions";

@Injectable({
  providedIn: 'root'
})
export class SubmissionsService {
  public readonly submissionsListSubject: ReplaySubject<CountedAndPaginated<Submissions>>
    = new ReplaySubject<CountedAndPaginated<Submissions>>(1);

  constructor(
    private httpClient: HttpClient,
  ) { }

  public loadList(page: number): void {
    this.httpClient.get(`/rest/crm/submissions?page=${page + 1}&`)
      .pipe(
        first(),
      )
      .subscribe((result: CountedAndPaginated<Submissions>) => {
        this.submissionsListSubject.next(result);
      });
  }

  public loadArchivesList(page: number): void {
    this.httpClient.get(`/rest/crm/submissions/archives?page=${page + 1}&`)
      .pipe(
        first(),
      )
      .subscribe((result: CountedAndPaginated<Submissions>) => {
        this.submissionsListSubject.next(result);
      });
  }
  public send(formData: object): Observable<any> {
    return this.httpClient.post(`/rest/crm/submissions`, formData)
      .pipe(
        take(1)
      );
  }
}
